import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Modal,
  Checkbox,
  Typography,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
  CircularProgress,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
} from "@mui/material";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { CardMedia } from "@mui/material";
import bundle from "../../assests/Images/bundle.png";
import starIcon from "../../assests/Images/starIcon.png";
import lineIcon from "../../assests/Images/lineIcon2.png";
import joyLogo from "../../assests/Images/joyLogo.png";
import musicLogo from "../../assests/Images/music.svg";
import downloadLogo from "../../assests/Images/download.svg";
import saveLogo from "../../assests/Images/save1.svg";
import info from "../../assests/Images/info.png";
import info1 from "../../assests/Images/info1.png";
import info2 from "../../assests/Images/info2.png";
import info3 from "../../assests/Images/info3.png";
import camera from "../../assests/Images/camera.svg";

import { Container } from "@mui/system";
import { MessageAPIService } from "../../services/api";
import music1 from "../../assests/audio/happykids.mp3";
import music2 from "../../assests/audio/cartoonIntro.mp3";
import music3 from "../../assests/audio/cute.mp3";
import music4 from "../../assests/audio/jingle.mp3";
import music5 from "../../assests/audio/lemonadeStand.mp3";

const ffmpeg = new FFmpeg();

const VideoWithTransitions = ({ imageFiles: externalImages = [], onClose,user_phone }) => {
  const [ready, setReady] = useState(false);
  const [imageFiles, setImageFiles] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [audioFile, setAudioFile] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [progress, setProgress] = useState(0);
  const [open, setOpen] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const [selectedAudio, setSelectedAudio] = useState(null);

  const audioOptions = [
    { name: "Happy Tune", file: music1 },
    { name: "Joyful Echo", file: music2 },
    { name: "Timeless Tune", file: music3 },
    { name: "Memory Lane", file: music4 },
    { name: "Serene Vibes", file: music5 },

  ];

  useEffect(() => {
    if (externalImages.length > 0) {
      setImageFiles(externalImages);
      setSelectedImages(
        externalImages.map((file) => ({ file, selected: true }))
      );
      setOpen(true);
    }
  }, [externalImages]);

  // Load FFmpeg on mount
  useEffect(() => {
    const load = async () => {
      if (!ffmpeg.loaded) {
        ffmpeg.on("progress", ({ ratio }) => {
          setProgress(Math.round(ratio * 100));
        });
        await ffmpeg.load();
        setReady(true);
      }
    };
    load();
  }, []);

  const handleDownload = () => {
    // Create a temporary link and trigger download
    const a = document.createElement("a");
    a.href = videoUrl;
    a.download = "Joy_Memory.mp4";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Open popup after download
    setOpenInfo(true);
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setImageFiles(files);
    setSelectedImages(files.map((file) => ({ file, selected: true })));
    setOpen(true);
  };

  const handleCheckboxChange = (index) => {
    setSelectedImages((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, selected: !item.selected } : item
      )
    );
  };

  const handleAudioUpload = (e) => {
    if (e.target.files[0]) setAudioFile(e.target.files[0]);
  };

  const generateVideo = async () => {
    setLoading(true);
    setVideoUrl(null);
    setProgress(0);

    try {
      if (!ffmpeg.loaded) {
        console.log("FFmpeg not loaded, loading...");
        await ffmpeg.load();
        console.log("FFmpeg loaded successfully.");
      }

      const selected = selectedImages
        .filter((img) => img.selected)
        .map((img) => img.file);

      for (let i = 0; i < selected.length; i++) {
        const res = await fetch(URL.createObjectURL(selected[i]));
        const buf = await res.arrayBuffer();
        await ffmpeg.writeFile(`img${i}.png`, new Uint8Array(buf));
      }

      if (audioFile) {
        const audioSrc = typeof audioFile === "string" ? audioFile : URL.createObjectURL(audioFile);
        const audioRes = await fetch(audioSrc);
        const audioBuf = await audioRes.arrayBuffer();
        await ffmpeg.writeFile("audio.mp3", new Uint8Array(audioBuf));
      }

      const pauseDuration = 3;
      const transitionDuration = 1;
      const totalDuration = pauseDuration + transitionDuration;

      for (let i = 0; i < selected.length; i++) {
        await ffmpeg.exec([
          "-loop",
          "1",
          "-t",
          totalDuration.toString(),
          "-i",
          `img${i}.png`,
          "-vf",
          "scale=520:720:flags=lanczos",  // or another size
          "-r", "30",
          "-c:v", "libx264",
          "-crf", "23",
          "-preset", "slow",
          `clip${i}.mp4`,
        ]);
      }

      const inputArgs = selected.map((_, i) => ["-i", `clip${i}.mp4`]).flat();
      const transition = "slideleft";

      let filter = `[0:v][1:v]xfade=transition=${transition}:duration=${transitionDuration}:offset=${pauseDuration}[v0];`;
      for (let i = 2; i < selected.length; i++) {
        const offset = pauseDuration * i;
        filter += `[v${
          i - 2
        }][${i}:v]xfade=transition=${transition}:duration=${transitionDuration}:offset=${offset}[v${
          i - 1
        }];`;
      }

      const outputMap = `[v${selected.length - 2}]`;

      const finalArgs = [
        ...inputArgs,
        ...(audioFile ? ["-i", "audio.mp3"] : []),

        "-filter_complex",
        filter.slice(0, -1),

        "-map",
        outputMap,

        ...(audioFile ? ["-map", `${selected.length}:a`] : []),

        "-c:v", "libx264",
        "-profile:v", "baseline",
        "-level", "3.0",
        "-pix_fmt", "yuv420p",

        "-c:a", "aac",
        "-b:a", "128k",
        "-shortest",

        "-movflags", "+faststart",
        "-preset", "ultrafast",

        "output.mp4"
      ];

      await ffmpeg.exec(finalArgs);
      const data = await ffmpeg.readFile("output.mp4");
      const url = URL.createObjectURL(
        new Blob([data.buffer], { type: "video/mp4" })
      );
      setVideoUrl(url);
    } catch (err) {
      console.error("Error generating video:", err);
      console.log("FS:", await ffmpeg.listDir("/"));
    } finally {
      setLoading(false);
    }
  };

  const handleSaveToJournal = async () => {
    setSaving(true);
    try {
      const res = await fetch(videoUrl);
      const blob = await res.blob();

      const reader = new FileReader();
      reader.onloadend = async() => {
        const base64String = reader.result; // Remove data:video/mp4;base64,...

        let payload = {
          From: user_phone,
          Body: "",
          NumMedia: 1,
          MediaUrl0: base64String
        };

        const getImageUrl = await MessageAPIService.getImageURL(payload);

        if(getImageUrl?.saved_files?.[0]){

          payload = {
            From: user_phone,
            Body:"",
            media_url:getImageUrl?.saved_files?.[0],
            media_type:"reel"
          }
          const createJournal = await MessageAPIService.createJournal(payload);

          if(createJournal)
          {
            setSaving(false);

            onClose();
          }
        }
      };
      reader.readAsDataURL(blob);
    } catch (error) {
      setSaving(false);
      console.error("Error converting video to base64:", error);
    }
  };

  return (
    <Container sx={{ background:"#f8fafd",height:"100%"}}>

        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <img src={starIcon} alt="Star Icon" style={{ width: 60, height: "auto",marginTop:"40px" }} />
          <img src={joyLogo} alt="Joy Logo" style={{ width: 120, height: "auto" }} />
          <img src={lineIcon} alt="Line Icon" style={{ width: 60, height: "auto" ,marginTop:"40px"}} />
        </Box>
        {saving ?
          <>
          <Box sx={{alignContent:"center", height:"50vh"}}>
            <Box display="flex" justifyContent="center" alignItems="center" mt="10%">
              <CircularProgress />
            </Box>
            <Box display="flex" justifyContent="center" alignItems="center"  textAlign="center" mt={2}>
              Preserving your story, one frame at a time.
            </Box>
          </Box>
          </>
      :
        <>
      <Box
        sx={{
          p: "0px 32px",
          maxWidth: 500,
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* <Button variant="contained" component="label">
          Upload Images
          <input type="file" hidden multiple accept="image/*" onChange={handleImageUpload} />
        </Button> */}


        <Box display="flex" gap={2} mt={2} sx={{width:"100%",justifyContent:"center"}}>
          {/* {!videoUrl && !loading &&
            <Button variant="outlined" component="label" sx={{width:"60%",color:"#005cff" ,border:"1px solid #005cff", "@media (max-width: 440px)": {width:"100%"}}}>
              <img src={musicLogo} alt="Music Logo" style={{ width: 20, height: "auto", marginRight:"5px" }} />  Add Music
              <input
                type="file"
                hidden
                accept="audio/*"
                onChange={handleAudioUpload}
              />
            </Button>

          } */}

        </Box>

       {!videoUrl && !loading && <Box mt={2} sx={{ width: "100%", textAlign: "center" }}>
        <FormControl component="fieldset">
    <FormLabel component="legend" sx={{ fontSize: "1rem", mb: 2 }}>
      🎵 Select a Music Track:
    </FormLabel>
    <RadioGroup
      aria-label="music-track"
      name="music-track"
      value={selectedAudio}
      onChange={(e) => {
        const selected = audioOptions.find((opt) => opt.file === e.target.value);
        setSelectedAudio(e.target.value);
        setAudioFile(selected.file);
      }}
    >
      {audioOptions.map((option, idx) => (
        <FormControlLabel
          key={idx}
          value={option.file}
          control={<Radio sx={{ color: "#005cff", "&.Mui-checked": { color: "#005cff" } }} />}
          label={option.name}
        />
      ))}
    </RadioGroup>
  </FormControl>
</Box>
}

        {/* {!videoUrl && !loading && audioFile &&
          <audio controls style={{ marginTop: "10px" }}>
          <source
            src={
              typeof audioFile === "string"
                ? audioFile
                : URL.createObjectURL(audioFile)
            }
            type="audio/mp3"
          />
          Your browser does not support the audio element.
          </audio>
        } */}


{!videoUrl && !loading &&selectedAudio && (
  <audio
    key={selectedAudio} // 👈 forces re-render on src change
    controls
    style={{ marginTop: "10px" }}
  >
    <source src={selectedAudio} type="audio/mp3" />
    Your browser does not support the audio element.
  </audio>
)}

        {!videoUrl && !loading &&
          <Box mt={3} sx={{display:"flex",width:"100%",justifyContent:"center",marginBottom:"8px"}}>
            <Button
              variant="contained"
              // color="#ffffff"
              sx={{background:"#005cff",color:"#ffffff",width:"60%","@media (max-width: 440px)": {width:"100%"}}}
              disabled={
                loading || selectedImages.filter((i) => i.selected).length < 2
              }
              onClick={generateVideo}
              size="large"
            >
             <img src={camera} alt="camera Logo" style={{ width: 18, height: "auto", marginRight:"5px" }} /> {loading ? "Generating..." : "Create Video"}
            </Button>
          </Box>
        }
        {/* {!ready ? <CircularProgress /> : <Button onClick={generateVideo}>Generate Video</Button>} */}

        {loading && (
          <Box mt={5} textAlign="center">
            <img src={bundle} alt="Loading..." style={{ width: "80px" }} />
            <Typography variant="body2" color="textSecondary" mt={1}>
              We’re stitching your memories together...
            </Typography>
            <Box mt={2}>
              {/* <LinearProgress variant="determinate" value={progress} /> */}
              {/* <Typography variant="caption">{progress}%</Typography> */}
            </Box>
          </Box>
        )}

        {videoUrl && (
          <Box textAlign="center">
            <CardMedia
              component="video"
              src={videoUrl}
              controls
              loop
              sx={{
                borderRadius: "14px",
                width: "100%",
                maxWidth: 400,
                height: 340,
                objectFit: "contain",
                boxShadow: 2,
              }}
            />
            <Box sx={{display:"grid"}}>


            </Box>
          </Box>
        )}

        {videoUrl &&
          <>
            <Button
              // href={videoUrl}
              onClick={handleDownload}
              // download="video.mp4"
              variant="outlined"
              color="success"
              sx={{ mt: 2,color:"#005cff",width:"60%","@media (max-width: 440px)": {width:"100%"} }}
            >
            <img src={downloadLogo} alt="Download Logo" style={{ width: 20, height: "auto", marginRight:"5px" }} /> Download Reel
            </Button>
            <Button
              onClick={handleSaveToJournal}
              variant="outlined"
              sx={{ mt: 2, color:"#005cff",width:"60%","@media (max-width: 440px)": {width:"100%"}  }}
            >
            <img src={saveLogo} alt="Download Logo" style={{ width: 20, height: "auto", marginRight:"5px" }} /> Save to journal
            </Button>
            </>
        }

        {onClose && (
            <Button variant="outlined" color="error" sx={{ mt: 2,color:"#ff2999",width:"60%",border:"1px solid #ff2999", "@media (max-width: 440px)": {width:"100%"} }} onClick={onClose}>
              Cancel
            </Button>
          )}
      </Box>

      <Dialog open={openInfo} onClose={() => setOpenInfo(false)} sx={{zIndex:5000}}>
         <DialogTitle>📥 Find Your Download!</DialogTitle>
                <DialogContent>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold', mr: 1 }}>1.</Typography>
            <Typography variant="body2">
              Look for the Download Icon ⬇️ in your browser address bar
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold', mr: 1 }}>2.</Typography>
            <Typography variant="body2">
              Tap the Icon to see a list of your recent downloads. 👉 Tap the downloaded file to open it, play it or save it to your photos
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold', mr: 1 }}>3.</Typography>
            <Typography variant="body2">
              Don’t See the Icon? Tap the <img src={info1} width="25px" alt="Aa" loading="eager" /> or <img src={info2} alt="download" width="25px" loading="eager" /> button in Safari’s address bar → Select “Show Downloads”
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenInfo(false)} variant="contained" sx={{color:"#ffffff", background:"#005cff"}}>Got it!</Button>
        </DialogActions>
      </Dialog>

      </>
    }
    </Container>
  );

};

export default VideoWithTransitions;
